let regulars = {};
regulars.mobile = /^1\d{10}$/

export default regulars


// WEBPACK FOOTER //
// ./src/utils/regularUtils.js